var path = '/pages/billing/position_links/directives/billable_link/billable_link-directive.tpl.html';
var html = "<a ng-if=\"vm.show\" target=\"_blank\" ng-click=\"vm.doClickAction()\">\n    {{vm.label}}\n</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing/position_links/directives/billable_link/billable_link-directive.tpl.html
// module id = 2204
// module chunks = 1